<div class="confirm-section" [formGroup]="form()">
  <h3 class="confirm-section__title">{{ "MOVEMENT.SECTIONS.ADDITIONAL_INFORMATION" | translate }}</h3>
  <p class="confirm-section__subtitle">{{ "MOVEMENT.SECTIONS.ADDITIONAL_INFORMATION_SUBTITLE" | translate }}</p>

  <div class="input-group">
    <label for="confirm-driver">{{ "MOVEMENT.FORM.DRIVER" | translate }} <span class="red-color">*</span></label>
    <sxw-dropdown-input
      id="confirm-driver"
      formControlName="driver"
      [icon]="searchIcon"
      [query]="{
        name: 'listCustomer',
        select: [driverQuery],
        params: [
          { field: 'isDriver', value: true },
          { field: 'enabled', value: true },
        ],
      }"
      optionIdentifier="id"
      optionLabel="mainInfo.firstName"
      [querySearchBy]="driverSearchFields"
      placeholder="MOVEMENT.FORM.DRIVER_PLACEHOLDER">
      <ng-template let-driver>
        <span class="driver-option">
          <span class="driver-option__main">
            <span class="driver-option__code">{{ driver.personalData?.fiscalCode || "-" }}</span>
            -
            <span>{{ driver.mainInfo?.firstName }} {{ driver.mainInfo?.lastName }}</span>
          </span>
          <span class="driver-option__contacts">
            {{ driver.contactInfo?.mobileNumber?.mobile || "-" }} - {{ driver.contactInfo?.email?.email || "-" }}
          </span>
        </span>
      </ng-template>
      <ng-template #selectedContent let-driver>
        <span>{{ driver?.mainInfo?.firstName }} {{ driver?.mainInfo?.lastName }}</span>
      </ng-template>
    </sxw-dropdown-input>
    <span class="input-hint">{{ "MOVEMENT.HINTS.SEARCH_AND_SELECT_DRIVER" | translate }}</span>
  </div>

  <div class="input-group">
    <label for="confirm-external-note">{{ "MOVEMENT.FORM.EXTERNAL_NOTE" | translate }}</label>
    <sxw-text-area
      id="confirm-external-note"
      formControlName="externalNote"
      [rows]="3"
      [maxlength]="2000"
      placeholder="MOVEMENT.FORM.EXTERNAL_NOTE_PLACEHOLDER" />
    <span class="input-hint">{{ "MOVEMENT.HINTS.EXTERNAL_NOTE" | translate }}</span>
  </div>

  <div class="input-group">
    <label>{{ "MOVEMENT.FORM.FILES" | translate }}</label>
    <app-file-picker
      formControlName="files"
      [multiple]="true"
      [subTitle]="'COMMON.UPLOAD_FILE.SUPPORT_DOCUMENTS'"
      [browse]="'COMMON.UPLOAD_FILE.BROWSE'"
      [showSelectScan]="false"
      [showTakePhoto]="false" />
  </div>

  <app-internal-note [control]="form().controls.note" />
</div>
